<script>
import config from "@/config";

const routes = [
  {
    path: "/",
    component: () => import("@/views/default/index.vue"),
    children: [
      {
        path: "/",
        redirect: "/login"
      },
      {
        path: "/login",
        component: () => import("@/views/default/_login.vue")
      },
      {
        path: "/logout",
        component: () => import("@/views/default/_logout.vue")
      },
      {
        path: "/expired",
        component: () => import("@/views/default/_expired.vue")
      },
      {
        path: "/denied",
        component: () => import("@/views/default/_denied.vue")
      },
      {
        path: "/firstTime",
        component: () => import("@/views/default/_firstTime.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/resetPassword",
        component: () => import("@/views/default/_resetPassword.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/security",
        component: () => import("@/views/default/_security.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/otp",
        component: () => import("@/views/default/_otp.vue"),
        meta: { requiredLoggedIn: true}
      }
    ]
  },
  {
    path: "/account",
    component: () => import("@/views/account/index.vue"),
    meta: { requiredLoggedIn: true },
    children: [
      {
        path: "/messages",
        component: () => import("@/views/account/_messages.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/settings",
        component: () => import("@/views/account/_settings.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/overview",
        component: () => import("@/views/account/_overview.vue"),
        meta: { requiredLoggedIn: true }
      }
    ]
  },
  {
    path: "/account",
    component: () => import("@/views/account/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account, config.accessRoles.editAccount, config.accessRoles.subAccount, config.accessRoles.editLimit, config.accessRoles.editOperatorLimit] },
    children: [
      {
        path: "/newAccount",
        component: () => import("@/views/account/_newAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount]}
      },
      // {
      //   path: "/search",
      //   component: () => import("@/views/account/_search.vue"),
      //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      // },
      {
        path: "/subAccount",
        component: () => import("@/views/account/_subAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subAccount]}
      },
      {
        path: "/accountList",
        component: () => import("@/views/account/_accountList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account, config.accessRoles.editLimit]}
      },
      {
        path: "/viewDownline",
        component: () => import("@/views/account/_viewDownline.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/ipSettings",
        component: () => import("@/views/account/_ipSettings.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount]}
      },
      {
        path: "/editBetLimit",
        component: () => import("@/views/account/_editBetLimit.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editOperatorLimit]}
      }
    ]
  },
  {
    path: "/report",
    component: () => import("@/views/report/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] },
    children: [
      // {
      //   path: "/report",
      //   redirect: "/settlementHistory"
      // },
      {
        path: "/settlementHistory",
        component: () => import("@/views/report/_settlementHistory.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      // {
      //   path: "/dailyStatementMember",
      //   component: () => import("@/views/report/_dailyStatementMember.vue"),
      //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      // },
      {
        path: "/dailyWinlose",
        component: () => import("@/views/report/_dailyWinlose.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      // {
      //   path: "/dailyWinloseDetail",
      //   component: () => import("@/views/report/_dailyWinloseDetail.vue"),
      //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      // },
      // {
      //   path: "/dailyWinloseByPlatformDetail",
      //   component: () => import("@/views/report/_dailyWinloseByPlatformDetail.vue"),
      //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      // },
      {
        path: "/dailyWinloseByMatch",
        component: () => import("@/views/report/_dailyWinloseByMatch.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseByPlatform",
        component: () => import("@/views/report/_dailyWinloseByPlatform.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/cancelledBetList",
        component: () => import("@/views/report/_cancelledBetList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/gameResult",
        component: () => import("@/views/report/_gameResult.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      // {
      //   path: "/gameResultDetail",
      //   component: () => import("@/views/report/_gameResultDetail.vue"),
      //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      // },
      {
        path: "/matchResult",
        component: () => import("@/views/report/_matchResult.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/systemParlay",
        component: () => import("@/views/report/_systemParlay.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/tournamentRefundList",
        component: () => import("@/views/report/_tournamentRefundList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseTournament",
        component: () => import("@/views/report/_dailyWinloseTournament.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
    ]
  },
  {
    path: "/stock",
    component: () => import("@/views/stock/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] },
    children: [
      {
        path: "/stock",
        redirect: "/betList"
      },
      {
        path: "/betListHDPOUDetails",
        component: () => import("@/views/stock/_betListHDPOUDetails.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListHDPOU",
        component: () => import("@/views/stock/_betListHDPOU.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListOXTOEMLDetails",
        component: () => import("@/views/stock/_betListOXTOEMLDetails.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListOXTOEML",
        component: () => import("@/views/stock/_betListOXTOEML.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListTG",
        component: () => import("@/views/stock/_betListTG.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListCS",
        component: () => import("@/views/stock/_betListCS.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListHTFT",
        component: () => import("@/views/stock/_betListHTFT.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListDC",
        component: () => import("@/views/stock/_betListDC.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betListFGLG",
        component: () => import("@/views/stock/_betListFGLG.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/betList",
        component: () => import("@/views/stock/_betList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      },
      {
        path: "/memberOutstanding",
        component: () => import("@/views/stock/_memberOutstanding.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
      }
    ]
  },
  {
    path: "/logs",
    component: () => import("@/views/logs/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] },
    children: [
      {
        path: "/logs",
        redirect: "/betLimitLog"
      },
      {
        path: "/betLimitLog",
        component: () => import("@/views/logs/_betLimitLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      }
    ]
  },
  {
    path: "/tournament",
    component: () => import("@/views/logs/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account, config.accessRoles.tournament] },
    children: [
      {
        path: "/tournament",
        redirect: "/tournamentMatch"
      },
      {
        path: "/tournamentMatch",
        component: () => import("@/views/tournament/_tournamentMatch.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.tournament] }
      }
    ]
  },

]

export default routes;
</script>
